import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TrackingService {
  trackEvent(event: string, data?: any): void {
    if (!(window as any).gtag) {
      return;
    }

    (window as any).gtag('event', event, data);
  }
}
